
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import MaterialIcon from '@/components/MaterialIcon.vue';

export default defineComponent({
  name: 'AppSubNavigation',
  components: {
    MaterialIcon
  },
  setup() {
    const route = useRoute();
    const hasChildren = computed(() => !!route.matched[0]?.children.length);
    const subRoutes = computed(() => route.matched[0]?.children.map(child => child));

    return {
      hasChildren,
      subRoutes
    };
  }
});
